import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../button/button';
import { PageDivider } from '../../profile-page/page-divider';
import { MicrosoftEntraIdSignInButton } from '../../sign-in-form/sso/microsoft-entra-id/microsoft-entra-id-sign-in-button';
import { Stack } from '../../stack/stack';

type Props = {
  token: string;
  disabled: boolean;
  onPasswordSelection: () => void;
  hidePasswordOption?: boolean;
};

const ChooseAuthentication = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={1.5}>
      <Stack direction="column" justifyContent="flex-end" spacing={0.5}>
        {!props.hidePasswordOption && (
          <>
            <Button
              color="primary"
              disabled={props.disabled}
              type="button"
              variant="contained"
              onClick={() => props.onPasswordSelection()}
            >
              {t('continue', { ns: 'common' })}
            </Button>

            <PageDivider word={t('or', { ns: 'common' })} />
          </>
        )}

        <MicrosoftEntraIdSignInButton disabled={props.disabled} token={props.token} />
      </Stack>
    </Stack>
  );
};

export { ChooseAuthentication };
